/**
 * User preferences utilities
 * Stores user preferences in localStorage
 */

import { UnitPreference } from '../types/vitalSigns'
import type { ThemePreference } from '../types/theme'

const UNIT_PREFERENCE_KEY = 'clnicl_unit_preference'
const THEME_PREFERENCE_KEY = 'clnicl_theme_preference'

/**
 * Get user's unit preference (Imperial/Metric)
 * Defaults to 'metric'
 */
export function getUnitPreference(): UnitPreference {
  if (typeof window === 'undefined') return 'metric'
  const saved = localStorage.getItem(UNIT_PREFERENCE_KEY)
  return saved === 'imperial' || saved === 'metric' ? saved : 'metric'
}

/**
 * Set user's unit preference
 */
export function setUnitPreference(preference: UnitPreference): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(UNIT_PREFERENCE_KEY, preference)
}

/**
 * Get user's theme preference
 * Defaults to 'standard'.
 */
export function getThemePreference(): ThemePreference {
  if (typeof window === 'undefined') return 'standard'

  const saved = localStorage.getItem(THEME_PREFERENCE_KEY) as ThemePreference | null
  if (saved === 'standard' || saved === 'dark' || saved === 'accessibility') {
    return saved
  }

  return 'standard'
}

/**
 * Set user's theme preference
 */
export function setThemePreference(theme: ThemePreference): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(THEME_PREFERENCE_KEY, theme)
}

